import React, { useState, useEffect } from "react";
import { BarChart3, Cookie } from "lucide-react";
import { PHONE, EMAIL } from "../mock";

export const Footer = () => (
  <footer className="bg-[#14102e] text-white/70 py-14">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-[#7c3aed] text-white">
            <BarChart3 className="w-5 h-5" strokeWidth={2.5} />
          </span>
          <span className="font-display text-2xl font-semibold tracking-tight text-white">
            T4<span className="text-[#7c3aed]">TECH</span>
          </span>
        </div>
        <div className="text-sm">
          <a href={`tel:${PHONE.replace(/\s/g, "")}`} className="hover:text-[#7c3aed] transition-colors">
            {PHONE}
          </a>
          <span className="mx-3 text-white/20">|</span>
          <a href={`mailto:${EMAIL}`} className="hover:text-[#7c3aed] transition-colors">
            {EMAIL}
          </a>
        </div>
      </div>

      <div className="mt-10 pt-8 border-t border-white/10 space-y-4">
        <p className="text-xs font-semibold tracking-[0.18em] uppercase text-white/40">
          Independent Third-Party Disclaimer
        </p>
        <p className="text-sm leading-relaxed max-w-4xl">
          T4TECH is not affiliated with, endorsed by, or connected to any mobile
          network, broadband provider, or device manufacturer (including O2, EE,
          Vodafone, Three, Sky, BT or others). We are a fully independent service
          offering free general support and guidance. T4TECH is an
          internationally registered company providing independent, free support
          services to UK mobile and SIM customers remotely.
        </p>
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} T4TECH. All rights reserved. No fees, no commission.
        </p>
      </div>
    </div>
  </footer>
);

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("t4tech_cookie");
    if (!consent) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (val) => {
    localStorage.setItem("t4tech_cookie", val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 lg:inset-x-auto lg:left-1/2 lg:-translate-x-1/2 z-[60] max-w-3xl mx-auto">
      <div className="rounded-2xl bg-[#14102e] text-white shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <span className="grid place-items-center w-11 h-11 rounded-full bg-[#7c3aed] shrink-0">
          <Cookie className="w-5 h-5" />
        </span>
        <p className="text-sm text-white/75 flex-1">
          We use a minimal set of cookies to keep the site secure and improve
          your experience. See our{" "}
          <span className="text-[#7c3aed] font-semibold underline cursor-pointer">Cookie Policy</span>{" "}
          for details.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={() => decide("declined")}
            className="rounded-full px-5 py-2.5 text-sm font-semibold text-white/80 hover:text-white transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => decide("accepted")}
            className="rounded-full bg-[#7c3aed] hover:bg-[#6d28d9] px-6 py-2.5 text-sm font-semibold text-white transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
